export default {
  loadUrl: newUrl => {
    window.location.href = newUrl;
  },
  updateUrl: newUrl => {
    window.history.replaceState({}, null, newUrl);
  },
};
